import { useAppSelector } from "@builder/store/store";
import "./style.scss";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

export enum TextType {
    TITLE_1 = "title1",
    TITLE_2 = "title2",
    TITLE_3 = "title3",
    TITLE_4 = "title4",
    TITLE_5 = "title5",
    SUBTITLE_1 = "subtitle1",
    SUBTITLE_2 = "subtitle2",
    SUBTITLE_3 = "subtitle3",
    SUBTITLE_4 = "subtitle4",
    BUTTON_1 = "button1",
    BUTTON_2 = "button2",
    BUTTON_3 = "button3",
    BUTTON_4 = "button4",
    BODY_1 = "body1",
    BODY_2 = "body2",
    BODY_3 = "body3",
    BODY_4 = "body4",
    DESCRIPTION = "description",
    BODY_LIGHT_XS = "bodyLightXS"
}

export type TextColors = "base-blue-dark" | "base-blue" | "blue" | "red" | "disabled" | "white" | "black" | "base-grey";
type TextSizes = "xxl" | "xl" | "l" | "m" | "s" | "xs" | "xxs";
type TextWeights = "light" | "medium" | "medium-heavy" | "semi-bold" | "bold";

export interface TextProps {
    text?: string;
    color?: TextColors;
    size?: TextSizes;
    weight?: TextWeights;
    id?: string;
    className?: string;
    style?: React.CSSProperties;
    translatePrefix?: string;
    type?: TextType;
    children?: string;
}

const OliverText: React.FC<TextProps> = ({ text, color, size, weight, id, className, style, translatePrefix, type, children }: TextProps) => {
    const isDarkMode = useAppSelector(state => state.systemUI.isDarkMode);
    const darkColor = !color && isDarkMode ? "var(--theme-text-color)" : undefined;
    const { t } = useTranslation();

    const textString = text || children || "";

    const textClassName = classNames("oliver-text", {
        [`text-color-${color}`]: color,
        [`text-size-${size}`]: size,
        [`text-weight-${weight}`]: weight,
        [`text-type-${type}`]: type,
        [`${className}`]: className
    });

    return (
        <p id={id} className={textClassName} style={{ ...style, color: darkColor }}>
            {translatePrefix !== undefined ? t(translatePrefix + textString) : textString}
        </p>
    );
};

export default OliverText;
